<template>
  <div class="page">
    <project-page-header ref="pageHeader" show-steps show-tabs show-stat :id="projectId">
      <template v-slot:actions="{ data }">
        <a-space>
          <template v-if="data.state === 7">
            <a-button class="v-px-sm" icon="form" size="default" type="indigo" @click="$router.push(`../plan/draft?id=${projectId}`)" v-if="!data.taskState && hasPermission('project:other:plan:draft')">制订项目计划</a-button>
            <a-button class="v-px-sm" type="indigo" icon="account-book" @click="$router.push(`../budget/draft?id=${projectId}`)" v-if="!data.budgetState && hasPermission('project:other:budget:draft')">填报项目预算</a-button>
            <template v-else-if="data.budgetState == 9">
              <a-button class="v-px-sm" icon="form" size="default" type="indigo" @click="$router.push(`../applybill/draft?id=${projectId}`)" v-if="hasPermission('project:other:applybill:draft')">财务请款单</a-button>
              <a-button class="v-px-sm" icon="form" size="default" type="indigo" @click="$router.push(`../progress/draft?id=${projectId}`)" v-if="hasPermission('project:other:progress:draft')">财务进展数据</a-button>
            </template>
            <a-button class="v-px-sm" icon="form" size="default" type="indigo" @click="$router.push(`../report/draft?id=${projectId}`)" v-if="hasPermission('project:other:report:draft')">项目报告</a-button>
            <a-button class="v-px-sm" icon="form" size="default" type="indigo" @click="$router.push(`../changeinfo/draft?id=${projectId}`)" v-if="hasPermission('project:other:changeinfo:draft')">项目变更</a-button>
            <a-button class="v-px-sm" type="indigo" icon="stop" @click="stop">项目终止</a-button>
            <a-button class="v-px-sm" icon="arrow-right" type="primary" @click="conclude">进入结项</a-button>
          </template>
          <template v-else-if="data.state === 8">
            <a-button class="v-px-sm" type="indigo" icon="stop" @click="stop">项目终止</a-button>
            <a-button class="v-px-sm" type="indigo" icon="arrow-left" @click="backword">退回至上一步</a-button>
            <a-button class="v-px-sm" type="primary" icon="arrow-right" @click="close">项目完成</a-button>
          </template>
          <template v-else-if="data.state === 9">
            <a-button class="v-px-sm" type="indigo" icon="arrow-left" @click="backword">退回至上一步</a-button>
          </template>
          <a-button class="v-px-sm" type="default" icon="left" @click="$router.push('../list')">返回列表</a-button>
        </a-space>
      </template>
    </project-page-header>
    <div class="v-px-md v-py-sm">
      <router-view />
    </div>
  </div>
</template>

<script>
import ProjectPageHeader from './common/page-header'
import { stopPrj, concludePrj, closePrj, backwardPrj } from '@/api/project/other'
export default {
  name: 'OtherView',
  components: {
    ProjectPageHeader,
  },
  data() {
    return {
      projectId: +this.$route.query.id,
      stoping: false,
      concluding: false,
      closing: false,
    }
  },
  watch: {
    $route() {
      this.init()
    },
  },
  methods: {
    init() {
      let { id } = this.$route.query
      if (id) {
        this.projectId = +id
      }
    },
    stop() {
      let { projectId } = this
      this.$confirm({
        title: '确认终止项目？',
        centered: true,
        onOk: () => {
          // 异步关闭
          this.stoping = true
          return new Promise((resolve, reject) => {
            stopPrj(projectId).then(({ data }) => {
              this.stoping = false
              if (data.success) {
                this.$message.success('操作成功')
                this.$router.push('../list')
                resolve()
              } else {
                this.$message.warn('操作失败')
                reject()
              }
            })
          }).catch(() => (this.stoping = false))
        },
      })
    },
    conclude() {
      let { projectId } = this
      this.$confirm({
        title: '确认进入项目结项？',
        centered: true,
        onOk: () => {
          // 异步关闭
          this.concluding = true
          return new Promise((resolve, reject) => {
            concludePrj(projectId).then(({ data }) => {
              this.concluding = false
              if (data.success) {
                this.$message.success('操作成功')
                this.$router.push('../list')
                resolve()
              } else {
                this.$message.warn('操作失败')
                reject()
              }
            })
          }).catch(() => (this.stoping = false))
        },
      })
    },
    close() {
      let { projectId } = this
      this.$confirm({
        title: '确认完成项目？',
        centered: true,
        onOk: () => {
          // 异步关闭
          this.closing = true
          return new Promise((resolve, reject) => {
            closePrj(projectId).then(({ data }) => {
              this.closing = false
              if (data.success) {
                this.$message.success('操作成功')
                this.$router.push('../list')
                resolve()
              } else {
                this.$message.warn('操作失败')
                reject()
              }
            })
          }).catch(() => (this.stoping = false))
        },
      })
    },
    backword() {
      let { projectId } = this
      this.$confirm({
        title: '确认退回至上一步？',
        centered: true,
        onOk: () => {
          return new Promise((resolve, reject) => {
            backwardPrj(projectId).then(({ data }) => {
              if (data.success) {
                this.$message.success('操作成功')
                this.$router.push('../list')
                resolve()
              } else {
                this.$message.warn('操作失败')
                reject()
              }
            })
          }).catch(() => this.$message.warn('操作失败'))
        },
      })
    },
    reloadRrj() {
      if (this.$refs.pageHeader) {
        this.$refs.pageHeader.load()
      }
    },
  },
  created() {
    this.init()
    this.$root.$on('reloadPrj', this.reloadRrj)
  },
}
</script>
